import { faqData } from "../../data";

export default {
    name: 'faqGroupsSectionID',
    title: 'FAQ Groups Section',
    type: 'document',
    fields: [
        {
            name: 'faqGroups',
            title: 'FAQ Groups',
            type: 'array',
            of: [
                {
                    type: 'object',
                    fields: [
                        { name: 'title', title: 'Group Title', type: 'string', validation: Rule => Rule.required() },
                        {
                            name: 'faqs',
                            title: 'FAQs',
                            type: 'array',
                            of: [
                                {
                                    type: 'object',
                                    fields: [
                                        { name: 'id', title: 'ID', type: 'number', validation: Rule => Rule.required() },
                                        { name: 'title', title: 'Question', type: 'string', validation: Rule => Rule.required() },
                                        { name: 'details', title: 'Answer', type: 'text', validation: Rule => Rule.required() },
                                        { name: 'sectionID', title: 'Section ID', type: 'string' }
                                    ]
                                }
                            ],
                            validation: Rule => Rule.required().min(1)
                        }
                    ]
                }
            ],
            validation: Rule => Rule.required().min(1),
            initialValue: faqData.faqGroups
        }
    ],
    preview: {
        prepare() {
            return {
                title: 'FAQ Groups Section',
                subtitle: 'FAQ Groups Section'
            }
        }
    }
} 